import React, { memo, useEffect, useCallback, useRef } from 'react';
import { Dimensions, View, Text, StyleSheet, Image } from 'react-native';
import { I18n, Container, FormFooter, Navigation } from '../../components';
import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../../constants/styles';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PENDING, REQUESTING, SUCCESS } from '../../../actions/statusTypes';
import { submitAccessRequest } from './slice';

import PersonForm from '../../cases/airforce/person_form.js';

const VERTICAL_LAYOUT_WIDTH = 1200;

const AccessRequestFormScreen = memo((props) => {
  const [submitSuccess, setSubmitSuccess] = React.useState(false);

  const formRef = useRef(null);

  const { width } = Dimensions.get('window');
  const [isVerticalLayout, setIsVerticalLayout] = React.useState(width < VERTICAL_LAYOUT_WIDTH);

  const handleDimsChange = useCallback(({ window: { width, height } }) => {
    setIsVerticalLayout(width < VERTICAL_LAYOUT_WIDTH);
  }, []);
  useEffect(function () {
    Dimensions.addEventListener('change', handleDimsChange);
    return function () {
      Dimensions.removeEventListener('change', handleDimsChange);
    };
  }, []);

  useEffect(() => {
    if (props.status === SUCCESS) {
      setSubmitSuccess(true);
    }
  }, [props.status]);

  function submit() {
    const submitObj = formRef.current?.getObjectToSubmit();
    if (!submitObj) {
      return;
    }
    const requestObj = {
      ...submitObj,
      employerKey: props.base,
    };
    delete requestObj.firstName;
    delete requestObj.lastName;
    if (!requestObj.clinicalLocation) delete requestObj.clinicalLocation;
    if (!requestObj.medicalService) delete requestObj.medicalService;
    if (!requestObj.rank) delete requestObj.rank;
    if (!requestObj.group) delete requestObj.group;
    props.actions.submitAccessRequest({ requestObj });
  }

  function cancel() {
    Navigation.dismissAllModals();
  }

  const submitSuccessView = (
    <View
      style={[
        !props.isVerticalLayout ? { minHeight: '100%' } : { flex: 1 },
        styles.successContainer,
      ]}
    >
      <View>
        <Image source={require('../../../../resources/icon-success-thank-you.png')} />
        <Text style={styles.requestSuccessLabel}>{I18n.t('auth.requestSuccessTitle')}</Text>
        <Text stlye={THEME.textRegular}>{I18n.t('auth.requestSuccessBody')}</Text>
      </View>
    </View>
  );

  return (
    <Container
      errorMessage={props.error?.message}
      scrollView={!submitSuccess}
      renderActivityOverlay={props.status === REQUESTING}
    >
      {submitSuccess ? (
        submitSuccessView
      ) : (
        <>
          <PersonForm
            ref={formRef}
            roles={props.formInfo?.roles}
            clinicalLocations={props.formInfo?.clinicalLocations}
            medicalServices={props.formInfo?.medicalServices}
            groups={props.formInfo?.groups}
            departments={props.formInfo?.departments}
            roleType={props.roleType}
            isVerticalLayout={isVerticalLayout}
          />
          <FormFooter
            saveLabel={I18n.t('auth.requestAccess')}
            cancelLabel={I18n.c1('cancel')}
            onSave={submit}
            onCancel={cancel}
            forceHorizontal={false}
            saveDisabled={props.status === REQUESTING}
            cancelDisabled={props.status === REQUESTING}
          />
        </>
      )}
    </Container>
  );
});

const styles = StyleSheet.create({
  successContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 100,
    paddingBottom: 100,
  },
  requestSuccessLabel: {
    ...FONT.FONT_SIZE_HUGE,
    ...FONT.FONT_SEMIBOLD,
    color: COLOR.text,
    fontSize: FONT_SIZE.enormous,
    marginTop: 30,
    marginBottom: 30,
    textTransform: 'uppercase',
  },
});

function mapStateToProps(state, ownProps) {
  const formInfo = state.screens.baseUnauthed.baseInfoData;
  return {
    formInfo,
    status: state.screens.baseUnauthed.inviteRequestStatus,
    error: state.screens.baseUnauthed.error,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ submitAccessRequest }, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AccessRequestFormScreen);
